import React, { lazy, Suspense } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'

import Layout from 'layouts'
import themes from 'devextreme/ui/themes'

const routes = [
  // Dashboards
  {
    path: '/dashboard/alpha',
    Component: lazy(() => import('pages/claims/dashboard')),
    exact: true,
  },

  // Auth Pages
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
  },
  {
    path: '/change-password',
    Component: lazy(() => import('pages/auth/change-password')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },

  // Claims
  {
    path: '/claims/dashboard',
    Component: lazy(() => import('pages/claims/dashboard')),
    exact: true,
  },
  {
    path: '/claims/claim',
    Component: lazy(() => import('pages/claims/claim')),
    exact: true,
  },
  {
    path: '/claims/search',
    Component: lazy(() => import('pages/claims/search')),
    exact: true,
  },
  {
    path: '/claims/customer',
    Component: lazy(() => import('pages/claims/customer')),
    exact: true,
  },

  // Cqs
  {
    path: '/cqs/dashboard',
    Component: lazy(() => import('pages/cqs/dashboard')),
    exact: true,
  },
  {
    path: '/cqs/rating',
    Component: lazy(() => import('pages/cqs/rating')),
    exact: true,
  },
  {
    path: '/cqs/search',
    Component: lazy(() => import('pages/cqs/search')),
    exact: true,
  },
]

const mapStateToProps = ({ settings, user }) => ({
  routerAnimation: settings.routerAnimation,
  theme: settings.theme,
  user
})

const Router = ({ history, routerAnimation, theme, user }) => {
  const dxTheme = theme === 'dark' ? 'generic.dark' : 'generic.soft'

  let defaultPage
  switch (user.role) {
    case "Accounting":
      defaultPage = "/claims/dashboard"
      break
    case "Cqs":
      defaultPage = "/cqs/dashboard"
      break
    default:
      defaultPage = "/claims/search"
  }
  themes.current(dxTheme)
  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                >
                  <Switch location={location}>
                    <Route exact path="/" render={() => <Redirect to={defaultPage} />} />
                    {routes.map(({ path, Component, exact }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={() => {
                          return (
                            <div className={routerAnimation}>
                              <Suspense fallback={null}>
                                <Component />
                              </Suspense>
                            </div>
                          )
                        }}
                      />
                    ))}
                    <Redirect to="/auth/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
